const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.12 70.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M57.17,7.18m5.95,13.34V65a5.45,5.45,0,0,1-5.44,5.44l-44.32-.33a5.44,5.44,0,0,1-5.43-5.44V59.49h2.65v5.13a2.8,2.8,0,0,0,2.79,2.8l44.32.33A2.81,2.81,0,0,0,60.48,65V23.13H46.27a6,6,0,0,1-6-5.95V3l-27-.31a2.77,2.77,0,0,0-2.75,2.78V35.69H7.93V5.42A5.42,5.42,0,0,1,13.35,0l29,.33h.62Zm-3.85,0L43,4.18v13a3.31,3.31,0,0,0,3.31,3.31Z",
    style: {
      fill: "#aaa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 38.34,
    width: 55.4,
    height: 19.39,
    rx: 2.54,
    style: {
      fill: "#00b1f6"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(2.55 53.97)",
    style: {
      fontSize: "16.465299606323242px",
      fill: "#fff",
      fontFamily: "Nunito-Black, Nunito Black",
      fontWeight: 800
    }
  }, "DO", /*#__PURE__*/React.createElement("tspan", {
    x: 25.83,
    y: 0,
    style: {
      letterSpacing: "0.04596551265968758em"
    }
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.75,
    y: 0,
    style: {
      letterSpacing: "0.000029655169457862957em"
    }
  }, "X")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocxIcon);
export default __webpack_public_path__ + "static/media/docx_icon.da4a42ba049af0408468ed552fae7ba3.svg";
export { ForwardRef as ReactComponent };